import { render, staticRenderFns } from "./UserBillingsSettings.vue?vue&type=template&id=d6b83368"
import script from "./UserBillingsSettings.vue?vue&type=script&lang=js"
export * from "./UserBillingsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports